import {createAction} from "@reduxjs/toolkit";
import * as types from '../../actionTypes';

export const setBool = createAction(types.VAR_BOOL, (isBoolean:boolean) => ({
    payload: isBoolean,
}));
